/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from 'react';
import {
  Container,
  FormHelperText,
  AddBox,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Tooth,
  StyledCrudTable,
} from './styles';
import { isEmpty } from 'lodash';
import { Hidden } from '@material-ui/core';
import AdornedTextField from '../adornedTextField';
import restApiClient from '../../services/restApiClient';
import FilterTree from '../../helpers/filterTree';
import Dentist from '../../forms/dentist';

const SelectDentistControl = ({
  data,
  className,
  id,
  enabled,
  uischema,
  schema,
  path,
  label,
  handleChange,
  onSuccess,
  config,
  errors,
  visible,
  disabled,
  required,
  selectedDentist = null,
  ...props
}) => {
  const [open, setOpen] = React.useState(false);
  const [dentist, setDentist] = useState({});
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState({ count: 0, values: [] });
  const [rowsPerPage, setRowsPerPage] = useState(3);
  const [orderBy, setOrderby] = useState({});
  const [searchBy, setSearchBy] = useState('');
  const columns = Dentist.tableSchema;

  const handleClickOpen = () => {
    if (enabled) {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    restApiClient.dentist
      .getAll(
        rowsPerPage,
        page * rowsPerPage,
        searchBy
          ? new FilterTree()
              .like('id', searchBy)
              .or()
              .like('name', searchBy)
              .toString()
          : null,
        orderBy
      )
      .then((e) => {
        setRows(e.data);
      });
  }, [rowsPerPage, page, orderBy, searchBy]);

  useEffect(() => {
    if (data) {
      restApiClient.dentist.findById(data).then((e) => {
        setDentist(e.data);
        handleChange?.(path, e.data?.id);
      });
    } else {
      setDentist({});
    }
  }, [handleChange, path, data]);

  return (
    <Hidden xsUp={!visible}>
      <Container>
        <AdornedTextField
          className={className}
          disabled={!enabled}
          error={!isEmpty(errors)}
          adornment={<Tooth />}
          clickableAdornment
          onAdornmentClick={handleClickOpen}
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onClick={handleClickOpen}
          label={label}
          InputLabelProps={{
            readOnly: true,
          }}
          required={required}
          value={!isEmpty(dentist) ? dentist?.name : ''}
          helperText={
            !isEmpty(errors) ? (
              <FormHelperText error>{`${errors}`}</FormHelperText>
            ) : (
              ''
            )
          }
          {...props}
        />
      </Container>

      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        open={open}
        onClose={handleClose}
      >
        <DialogContent>
          <StyledCrudTable
            title={'Seleção de Dentista'}
            modelActions={Dentist.actions}
            columns={columns}
            rows={rows}
            page={page}
            setPage={(page) => setPage(page)}
            rowsPerPage={rowsPerPage}
            availableRowsPerPage={[3]}
            setRowsPerPage={(rowsPerPage) => setRowsPerPage(rowsPerPage)}
            onOrderByChange={(orderBy) => setOrderby(orderBy)}
            orderBy={orderBy}
            setOrderBy={(value) => setOrderby(value)}
            searchBy={searchBy}
            setSearchBy={(value) => setSearchBy(value)}
            actions={{
              insert: {
                icon: <AddBox />,
                onClick: (id, data) => {
                  setDentist(data);
                  handleChange?.(path, id);
                  onSuccess?.(id);
                  handleClose();
                },
                title: 'Vincular',
                allowedActions: [Dentist.actions.getAll],
                allowDentist: true,
                selector: (row) =>
                  config?.completeData?.substituteDentist !== row.id &&
                  config?.completeData?.replacedDentist !== row.id &&
                  selectedDentist !== row.id,
              },
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleClose} color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </Hidden>
  );
};

export default SelectDentistControl;
